import { and } from 'airbnb-prop-types';
import PropTypes from 'prop-types';
/**
 * Custom prop type validator that checks string length.
 */

var maxLineLength = function maxLineLength(props, propName, componentName) {
  // eslint-disable-next-line no-underscore-dangle
  if (props.__dangerouslyAllowLongLabel) {
    return null;
  }

  var value = props[propName];
  /* 21 characters is the max number of characters
   * for iPhone 5's select element */

  var maxChars = 21;
  return typeof value === 'string' && value.length > maxChars ? new Error("Keep ".concat(propName, " in ").concat(componentName, " under ").concat(maxChars, " characters. Line length on ").concat(propName, " is ").concat(value.length - maxChars, " characters too long.")) : null;
};

export var OPTION_PROPS = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.bool]),
  label: and([maxLineLength, PropTypes.string]),
  disabled: PropTypes.bool,
  __dangerouslyAllowLongLabel: PropTypes.bool
};
export var OPTION_GROUP_PROPS = {
  title: and([maxLineLength, PropTypes.string]),
  options: PropTypes.arrayOf(PropTypes.shape(OPTION_PROPS))
};
export var SELECT_PROP_TYPES = {
  block: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  multiple: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape(OPTION_PROPS)), PropTypes.arrayOf(PropTypes.shape(OPTION_GROUP_PROPS))]).isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired
};
export var SELECT_DEFAULT_PROPS = {
  block: false,
  className: null,
  disabled: false,
  error: false,
  fullWidth: false,
  id: '',
  name: '',
  multiple: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {}
};